import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as globals from '../../globals';
import { AccountSelectorInputAsyncComponent } from '../../accounts/account-selector-input-async/account-selector-input-async.component';
import { Membership } from 'src/app/models/membership.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { first, firstValueFrom } from 'rxjs';
import { AccountsService } from 'src/app/services/accounts.service';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-accounts-access-token',
  templateUrl: './accounts-access-token.component.html',
  styleUrl: './accounts-access-token.component.scss'
})
export class AccountsAccessTokenComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private snackBar: MatSnackBar,
    private accountsService: AccountsService,
    public dialog: MatDialog,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isAdministrator = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
  }

  private async update() {
    if(!this.isAdministrator) {
      return;
    }
    try {
      this.loadingSpinner(true);

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          applicationId: this.accountSelectedId,
          dialogTitle: globals.aat,
          description: `${globals.aat_update}`,
          cautionaryMessage: '',
          okButtonTitle: globals.update,
        },
        width: '500px'
      });

      const result = await firstValueFrom(dialogRef
        .afterClosed()
        .pipe(first()));

      if (result) {
        const data = {
          account_id: this.accountSelectedId,
          aat: this.aat
        };

        this.accountsService.updateAAT(data).subscribe({
          next: (data) => {
            this.loadingSpinner(false);
            this.showMessage(data ? globals.aat_update_success : globals.aat_update_fail);
            this.refreshData();
          },
          error: (e) => {
            this.logger.logException(e);
            this.loadingSpinner(false);
            this.showMessage(globals.aat_update_fail);
          }
        });
      }

    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  private getAAT(accountId: number) {
    try {
      this.loadingSpinner(true);
      this.accountsService.getAAT(accountId).subscribe({
        next: (data) => {
          this.aat = data;
          this.loadingSpinner(false);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner(false);
        }
      });
    }
    catch {}
  }

  accountChanged = (accountId: number) => {
    this.accountSelectedId = accountId;
    this.refreshData();
  };

  accountCleared = () => this.accountSelectorInputAsyncComponent.clear();

  membershipAdded = (response) => this.refreshData();

  membershipCancelled = (response) => {};

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  private refreshData = () => this.getAAT(this.accountSelectedId);

  private showMessage = (message: string) => this.snackBar.open(message, null, { duration: 5000 });

  isAdministrator: boolean;
  isLoading: boolean;
  accountSelectedId = 0;
  aat: string = '';
  dataSource = new MatTableDataSource<Membership>();
  displayedColumns: string[] = globals.memberships_columns;
  
  @ViewChild(AccountSelectorInputAsyncComponent, { static: false }) accountSelectorInputAsyncComponent: AccountSelectorInputAsyncComponent;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

}
